<template>
  <div>
    <b-card>
      <b-alert
        :show="!stations.length"
        variant="danger">No stations found for this zone.</b-alert>
      <div v-if="stations.length">
        <span
          v-b-tooltip.hover
          :class="[zone.IS_BULK ? 'text-success' : 'text-secondary']"
          :value="zone.IS_BULK"
          class="mr-2 align-middle fa fa-check-circle-o fa-2x cursor-pointer"
          title="Select/Deselect all"
          @click="bulkChanged(zone)" />
        <select
          :value="zone.ASSIGNED_CLEANER"
          :zone-code="zone.CODE"
          :disabled="!zone.IS_BULK"
          class="form-control form-control-sm w-25 d-inline"
          @change="bulkCleanerChanged">
          <option
            :value="null"
            disabled>-- Please select cleaner --</option>
          <option
            v-for="cleaner in cleaners"
            :key="cleaner.CODE"
            :value="cleaner.CODE">{{ cleaner.USER_PROFILE_FIRST_NAME + ' ' + cleaner.USER_PROFILE_LAST_NAME }}</option>
        </select>
      </div>

      <hr v-if="stations.length" >

      <div
        v-for="(station) in stations"
        :key="station.CODE"
        class="mt-2">
        <span
          :class="[station.SELECTED ? 'text-success' : 'text-secondary']"
          class="mr-2 align-middle fa fa-check-circle-o fa-2x cursor-pointer"
          @click="selectStation(station)" />
        <b-btn
          :class="[station.COLLAPSED ? 'collapsed' : null]"
          :aria-controls="station.CODE"
          :aria-expanded="station.COLLAPSED ? 'true' : 'false'"
          :disabled="!station.SELECTED"
          size="sm"
          @click="toggleCollapse(station)">
          <i :class="[station.COLLAPSED ? 'icon-minus' : 'icon-plus']"/>
        </b-btn>
        <h5 class="ml-2 d-inline"><span class="badge badge-success">{{ station.NAME }}</span></h5>
        <label class="switch switch-pill switch-success float-right">
          <input
            :checked="station.ASSIGNMENT_STATUS === 1 ? true : false"
            :disabled="!station.SELECTED"
            :station-code="station.CODE"
            type="checkbox"
            class="switch-input"
            @change="statusChanged">
          <span class="switch-slider"/>
        </label>
        <select
          :value="station.ASSIGNED_CLEANER"
          :station-code="station.CODE"
          :disabled="zone.IS_BULK || !station.SELECTED"
          class="form-control form-control-sm w-25 float-right mr-2"
          @change="stationCleanerChanged">
          <option
            :value="null"
            disabled>-- Please select cleaner --</option>
          <option
            v-for="cleaner in cleaners"
            :key="cleaner.CODE"
            :value="cleaner.CODE">{{ cleaner.USER_PROFILE_FIRST_NAME + ' ' + cleaner.USER_PROFILE_LAST_NAME }}</option>
        </select>

        <b-collapse
          :id="station.CODE"
          v-model="station.COLLAPSED"
          class="mt-2">
          <car-view
            :cist-list="station.CIST_LIST"
            :assignments="station.ASSIGNMENTS"
            :station="station"/>
        </b-collapse>
      </div>
    </b-card>
  </div>
</template>
<script>
import CarView from './CarView'
import { Switch as cSwitch } from '@coreui/vue'
import { mapState } from 'vuex'

export default {
  name: 'StationView',
  components: {
    cSwitch,
    CarView
  },
  props: {
    stations: {
      type: Array,
      default: () => []
    },
    zone: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState('assignment', [
      'cleaners'
    ]),
  },
  methods: {
    toggleCollapse(station) {
      this.$store.commit('assignment/toggleStation', {stationCode: station.CODE})
    },
    selectStation(station) {
      this.$store.commit('assignment/stationSelected', station)
    },
    statusChanged(e) {
      let stationCode = e.target.getAttribute('station-code')
      let status = e.target.checked
      this.$store.commit('assignment/setAssignmentStatus', {stationCode: stationCode, status: status})
    },
    stationCleanerChanged (e) {
      let stationCode = e.target.getAttribute('station-code')
      let selectedCleaner = e.target.value
      this.$store.commit('assignment/setStationCleaner', {stationCode: stationCode, cleaner: selectedCleaner})
    },
    bulkCleanerChanged(e) {
      let zoneCode = e.target.getAttribute('zone-code')
      let selectedCleaner = e.target.value
      this.$store.commit('assignment/setBulkCleaner', {zoneCode: zoneCode, cleaner: selectedCleaner})
    },
    bulkChanged(zone) {
      this.$store.commit('assignment/bulkChanged', zone)
    }
  }
}
</script>
